import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-otp-detail-model',
  templateUrl: './otp-detail-model.component.html',
  styleUrls: ['./otp-detail-model.component.css']
})
export class OtpDetailModelComponent implements OnInit {
 @Input('tripDetailModalObj') trip: any;
 @Output() onCloseModal = new EventEmitter<string>();
 dataList = [];
  tripData = [];
  driverList = [];
  preDriverList = [];
  spaceTypeList= [];
  preSpaceTypes = []
  user;
  constructor(
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private levelOfServiceService : LevelOfServiceService,
  ) { }

  ngOnInit() {
     this.getUser()
  }

   getUser() {
      this.sharedDataService
        .getUser()
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.user = data
            this.getDriverList();
            this.getSpaceTypes();
            
          }
        });
    }

  getDriverList() {
    this.driverService.getDrivers(this.user.company._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driverList = data;
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
      );
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  closeModal() {
    this.onCloseModal.emit();
  }

   ngOnDestroy(): void {
      this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    }
}
